import { render } from "./TestCriteriaList.vue?vue&type=template&id=9500d428&scoped=true"
import script from "./TestCriteriaList.vue?vue&type=script&lang=js"
export * from "./TestCriteriaList.vue?vue&type=script&lang=js"

import "./TestCriteriaList.vue?vue&type=style&index=0&id=9500d428&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9500d428"]])

export default __exports__